import React, { useState, useMemo } from 'react';
import { Line } from 'react-chartjs-2';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';

ChartJS.register(
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Title,
    Tooltip,
    Legend
);

function GraphComponent({ data, heading }) {
    const [sampleSize, setSampleSize] = useState(100);

    // Slice the data based on the sample size
    const slicedData = sampleSize > 0 ? data.slice(-sampleSize) : data;

    const chartData = useMemo(
        () => ({
            labels: slicedData.map((point) => point.date), // x-axis labels
            datasets: [
                {
                    label: heading,
                    data: slicedData.map((point) => point.value), // y-axis data
                    borderColor: 'rgba(75, 192, 192, 1)',
                    backgroundColor: 'rgba(75, 192, 192, 0.2)',
                    borderWidth: 2,
                    tension: 0.3, // Smooth curves
                },
            ],
        }),
        [slicedData, heading]
    );

    const options = {
        responsive: true,
        plugins: {
            legend: {
                display: true,
                position: 'top',
            },
        },
        scales: {
            x: {
                title: {
                    display: true,
                    text: 'Date',
                },
            },
            y: {
                title: {
                    display: true,
                    text: heading,
                },
            },
        },
    };

    const handleSampleSizeChange = (e) => {
        const value = parseInt(e.target.value, 10);
        setSampleSize(isNaN(value) ? 0 : value); // Set to 0 if input is invalid
    };

    return (
        <div className="graph-component" style={{ fontFamily: 'Arial, sans-serif', padding: '0px' }}>
            <div className="graph-content" style={{ marginBottom: '20px' }}>
                <Line data={chartData} options={options} />
            </div>
            <div className="input-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
                <label
                    htmlFor="sampleSize"
                    style={{ marginRight: '10px', fontWeight: 'bold', fontSize: '16px' }}
                >
                    Sample Size:
                </label>
                <input
                    id="sampleSize"
                    type="number"
                    value={sampleSize}
                    onChange={handleSampleSizeChange}
                    style={{
                        width: '120px',
                        height: '40px',
                        borderRadius: '8px',
                        border: '1px solid #ccc',
                        padding: '5px 10px',
                        fontSize: '16px',
                        textAlign: 'center',
                        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)',
                        transition: 'border-color 0.2s',
                    }}
                    onFocus={(e) => (e.target.style.borderColor = 'rgba(75, 192, 192, 1)')}
                    onBlur={(e) => (e.target.style.borderColor = '#ccc')}
                />
            </div>
        </div>
    );
}

export default GraphComponent;
